import { IDashboardContext } from "../../../contexts/dashboard-context";

export function areSmartFiltersSupported(dashboard: IDashboardContext) {
	// We currently completely hide the filters panel button when smart filters are not supported
	return dashboard.areSmartFiltersSupported();
}

export function isPhotoFiltersPanelSupported(
	zone: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
) {
	if (!areSmartFiltersSupported(dashboard)) {
		return false;
	}

	if (zone) {
		return !zone.isEmpty && dashboard.canApplyColorEffect(zone);
	}

	return false;
}
